<template>
  <div class="saved-filter-container">
    <ContextMenu
      v-help.mouse="'V tomto menu si můžete uložit aktuální filtr na později nebo je editovat.'"
      :items="[
        {icon: 'fa-plus', label: 'Přidat filtr', action: _ => showAddFilter = true},
        {icon: 'fa-edit', label: 'Editovat filtry', action: _ => showEditFilter = true},
      ]"
    >
      <template #icon>
        <i class="fas fa-filter"></i>
      </template>
    </ContextMenu>
    <div v-for="(f, $index) in filters"
         :key="$index"
         class="saved-filter-button"
         :class="{'saved-filter-button--active': usedFilterIndex === $index}"
         @click="useFilter($index)"
    >
      {{ f.name }}
    </div>
    <Modal v-if="showAddFilter">
      <template #default>
        <input v-model="newName"
               type="text"
               class="form-control"
               placeholder="Název"
        >
      </template>
      <template #controls>
        <button
          class="asd-btn-confirm"
          @click="addFilter"
        >
          Přidat filtr
        </button>
      </template>
    </Modal>
    <Modal v-if="showEditFilter">
      <template #default>
        <table class="asd-table">
          <thead>
            <tr class="table-heading">
              <th></th>
              <th>
                Filtr
              </th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(f, $index) in filters"
                :key="$index"
            >
              <td>
                <button class="asd-btn-delete"
                        @click="removeFilter($index)"
                >
                  <i class="fas fa-trash"></i>
                </button>
              </td>
              <td>
                {{ f.name }}
              </td>
            </tr>
          </tbody>
        </table>
      </template>
      <template #controls>
        <button
          class="asd-btn-confirm"
          @click="showEditFilter = false"
        >
          Budiž
        </button>
      </template>
    </Modal>
  </div>
</template>

<script>
import _ from 'lodash'
import Modal from 'CORE/components/modal/modal'
import ContextMenu from 'CORE/components/context-menu'
import ensurePath from 'CORE/utils/ensure-path'

export default {
    name: 'SavedFilters',
    components: {
        Modal,
        ContextMenu,
    },
    props: {
        userFilter: {
            required: true,
            type: Object,
            default: _ => {return {}},
        },
        savedFilterId: {
            required: true,
            type: String,
        },
    },
    data() {
        return {
            newName: '',
            usedFilterIndex: undefined,
            showAddFilter: false,
            showEditFilter: false,
        }
    },
    computed: {
        showFiltersMenu() {
            return _.size(this.userFilter) > 0 ? true
                : _.size(this.filters) > 0
        },
        filtersLen() {
            return _.size(this.filters)
        },
        filters: {
            get() {
                return _.get(this.$store.getters.currentUser, `settings.saved-filter.${this.savedFilterId}`, [])
            },
            set(value) {
                const user = this.$store.getters.currentUser
                _.set(user, `settings.saved-filter.${this.savedFilterId}`, value)
            },
        },
    },
    watch: {
        userFilter(nv, ov) {
            if (this.usedFilterIndex !== null) {
                const selectedFilter = _.get(this.filters[this.usedFilterIndex], 'filter')
                // console.info(nv, selectedFilter)
                if (!_.isEqual(nv, selectedFilter)) {
                    this.usedFilterIndex = null
                }
            }
        },
    },
    mounted() {
        const currentUser = this.$store.getters.currentUser
        ensurePath(currentUser, ['settings/Object', 'saved-filter/Object', `${this.savedFilterId}/Array`])
    },
    methods: {
        async addFilter() {
            const newItem = {
                name: _.clone(this.newName),
                filter: _.cloneDeep(this.userFilter),
            }
            this.filters.push(newItem)
            await this.saveFilters()
            this.newName = ''
            this.showAddFilter = false
        },

        async saveFilters() {
            await this.$store.dispatch('updateUser', this.$store.getters.currentUser)
        },

        useFilter(index) {
            this.usedFilterIndex = index
            this.$emit('filter-changed', _.get(this.filters[index], 'filter'))
        },

        async removeFilter(index) {
            this.filters = _.filter(this.filters, (_, i) => i !== index)
            await this.saveFilters()
        },
    },
}
</script>

<style scoped lang="scss">
.saved-filter-container {
    display: flex;
}
.saved-filter-button {
    border: 1px solid silver;
    padding: 2px 5px;
    line-height: 1rem;
    height: 1.5rem;
    margin: 3px 2px;
    border-radius: 4px;
    cursor: pointer;
}
.saved-filter-button:hover {
    background-color: cornsilk;
    color: black
}
.saved-filter-button--active {
    background-color: cornsilk;
    border-color: #ffc107;
    font-weight: bold;
    color: black
}
</style>
